module.exports = __webpack_public_path__ + "img/et-backdrop.0d491924.png";